<div class="tc">
  <header class="tc-cab">
    <div class="tc-cab__textos">
      <h4 class="page-title" *ngIf="exibirTitulo">Cupons</h4>
      <p>Códigos de desconto que o cliente digita no pedido ou escolhe direto na loja.</p>
    </div>
    <button type="button" class="tc-btn" (click)="novoCupom()">
      <i class="fe-plus"></i> Novo cupom
    </button>
  </header>

  <label class="tc-config" for="cupomAcumulaDescontoPagamento">
    <span class="tc-config__icone"><i class="fe-layers"></i></span>
    <span class="tc-config__texto">
      <b>Somar cupom com o desconto da forma de pagamento (ex.: Pix)</b>
      <small>Desligado, o cliente recebe só o maior dos dois descontos. Assim você pode anunciar um cupom maior sem somar com o desconto do Pix.</small>
    </span>
    <span class="tc-switch">
      <input type="checkbox" role="switch" id="cupomAcumulaDescontoPagamento" name="cupomAcumulaDescontoPagamento"
             [(ngModel)]="empresa.cupomAcumulaDescontoPagamento" [disabled]="salvandoConfiguracao"
             (ngModelChange)="salveConfiguracaoCupom()"/>
      <span class="tc-switch__trilho"></span>
    </span>
  </label>

  <app-grid-cupons #gridGruponsAtivos></app-grid-cupons>
</div>
